// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreMoqRequirements = (client) => ({
    /**
     * `GET /store/moq-requirements`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreListMoqRequirements
     * @source packages/medusa-plugin-moq-v2/src/api/store/moq-requirements/route.ts
     */
    list: (query, headers) => client.fetch("/store/moq-requirements", { method: "GET", query, headers }),
});
//# sourceMappingURL=moq-requirements.js.map